/// <amd-module name="Feed/Legacy/Components/FeedContentComponent" />
import * as React from "react";
import { connect, DispatchProp } from "react-redux";
import { AnyAction } from "redux";

import { WrappedComponent } from "VSS/Platform/Layout";

import { HubActionStrings } from "Feed/Common/Constants/Constants";
import { getHubAction, IFeedNavigationAwareState } from "Feed/Core/Redux/Navigation";
import { FeedStore } from "Feed/Legacy/Stores/FeedStore";
import { PackageStore } from "Feed/Legacy/Stores/PackageStore";
import { IVssComponentContext } from "VSS/Platform/Layout";
export interface IFeedContentComponentProps {
    feedStore: FeedStore;
    packageStore: PackageStore;
}

interface IFeedContentComponentConnectedProps extends IFeedContentComponentProps {
    action: string;
}

function FeedContentComponent(props: IFeedContentComponentConnectedProps) {
    let componentDetails = { type: "", dependency: "" };

    switch (props.action) {
        case HubActionStrings.Connect:
            componentDetails = { type: "ms.feed.feed-connect.view", dependency: "ms.feed.feed-connect.view" };
            break;
        case HubActionStrings.CreateFeed:
            componentDetails = { type: "createfeed", dependency: "ms.feed.createfeed" };
            break;
        case HubActionStrings.ViewFeed:
            componentDetails = { type: "packagelist", dependency: "ms.feed.packagelist" };
            break;
        case HubActionStrings.ViewPackage:
            componentDetails = { type: "packagedetails", dependency: "ms.feed.packagedetails" };
            break;
        case HubActionStrings.Settings:
            componentDetails = { type: "feedsettings", dependency: "ms.feed.feedsettings" };
            break;
        case HubActionStrings.RecycleBin:
            componentDetails = { type: "recyclebin", dependency: "ms.feed.recyclebin" };
            break;
        case HubActionStrings.RecycleBinPackage:
            componentDetails = { type: "recyclebinpackage", dependency: "ms.feed.packagedetails" };
            break;
        case HubActionStrings.PackageDependencySelected:
            componentDetails = { type: "packagedependency", dependency: "ms.feed.packagedetails" };
            break;
    }

    return (
        <WrappedComponent
            wrappedType={componentDetails.type}
            dependencies={[componentDetails.dependency]}
            {...{
                feedFluxStore: props.feedStore,
                packageFluxStore: props.packageStore
            }}
        />
    );
}

function mapStateToProps(
    state: IFeedNavigationAwareState,
    ownProps: IFeedContentComponentProps
): IFeedContentComponentConnectedProps {
    return {
        feedStore: ownProps.feedStore,
        packageStore: ownProps.packageStore,
        action: getHubAction(state)
    };
}

export const ConnectedFeedContentComponent = connect(mapStateToProps)(FeedContentComponent);
